export enum QuizPage {
  // Section 0: Intro
  privacy = 'privacy',
  fertilityGoal = 'fertility-goal',
  medicalAdvisoryBoardInfo = 'medical-advisory-board-info', // Experiment: medicalAdvisoryBoard
  name = 'name',
  usps = 'usps',
  birthday = 'birthday',

  // Section 1: Goal
  fertilityGoalInfo = 'fertility-goal-info',
  promiseValueABTest = 'promise-value',
  birthControlMethod = 'birth-control-method',
  birthControlMethodInfo = 'birth-control-method-info',
  clinicalResearchReinforcementABTest = 'clinical-research-reinforcement',
  sideEffects = 'side-effects',
  sideEffectsInfo = 'side-effects-info',
  plannedPregnancyTiming = 'planned-pregnancy',
  learnAboutSexInfo = 'learn-about-sex-info',
  bestTimeInCycle = 'best-time-in-cycle',
  knowingYourSexDrive = 'knowing-your-sex-drive',
  sexDriveInfo = 'sex-drive-info',
  sexFrequency = 'sex-frequency',
  knowPregnantDays = 'know-pregnant-days',
  menstrualCycleInfo = 'menstrual-cycle-info',
  testimonialInfo = 'testimonial-info',
  // Postpartum goal feedback page
  hereToSupport = 'here-to-support',

  // Section 2: Cycle
  hormonalBirthControlUsage = 'hormonal-birth-control-usage',
  hormonalBirthControlHowLongPlan = 'hormonal-birth-control-how-long-plan',
  hormonalBirthControlHowLongPrevent = 'hormonal-birth-control-how-long-prevent',
  cycleLength = 'cycle-length',
  periodRegularity = 'period-regularity',
  periodRegularityInfo = 'period-regularity-info',
  cycleStartDate = 'cycle-start-date',
  // OurSyncABTest
  lastPeriodDate0 = 'last-period-date-0',
  lastPeriodDate1 = 'last-period-date-1',
  lastPeriodDate2 = 'last-period-date-2',
  lastPeriodDate3 = 'last-period-date-3',
  lastPeriodDate4 = 'last-period-date-4',
  lastPeriodDate5 = 'last-period-date-5',
  medicalConditionsPlan = 'medical-conditions-plan',
  medicalConditionsPrevent = 'medical-conditions-prevent',
  medicalConditionsInfo = 'medical-conditions-info',
  compareBirthControl = 'compare-birth-control',
  doctorInvolvement = 'doctor-involvement',
  partnerInvolvement = 'partner-involvement',
  partnerInvolvementInfo = 'partner-involvement-info',
  followPregnancyInfo = 'follow-pregnancy-info',
  plannedPregnancyInfo = 'planned-pregnancy-info',

  // Postpartum questions
  dateOfGivingBirth = 'date-of-giving-birth',
  periodBack = 'period-back',
  periodBackInfo = 'period-back-info',

  // Section 3: Cycle Changes
  cycleChangesStart = 'cycle-changes-start',
  cycleChangesEmotionalRange = 'emotional-range',
  cycleChangesEmotionalRangeInfo = 'emotions-info',
  cycleChangesSkinConditions = 'skin-conditions',
  cycleChangesSkinInfo = 'skin-info',
  cycleChangesMucusTypes = 'cervical-mucus-types',
  cycleChangesSexDrive = 'sex-drive-changes',
  cycleChangesSexDriveAndMucusInfo = 'sex-and-mucus-info',
  cycleChangesPainSymptoms = 'pain-symptoms',
  cycleChangesPainSymptomsInfo = 'pain-info',
  trackingInfo = 'tracking-info',

  // Postpartum questions
  recoveryInfo = 'recovery-info',
  physicalRecovery = 'physical-recovery',
  physicalSymptoms = 'physical-symptoms',
  physicalRecoveryInfo = 'physical-recovery-info',
  mentalStatus = 'mental-status',
  emotionsPostpartum = 'emotions-postpartum',
  mentalStatusInfo = 'mental-state-info',
  ncInsights = 'nc-insights',
  howSupported = 'how-supported',
  communitySupportInfo = 'community-support',
  ncResourcesInfo = 'nc-resources-info',
  birthControlPostpartumIntro = 'birth-control-intro',
  fertilityDetectionInfo = 'fertility-detection',
  ncEffectivenessPostpartum = 'nc-effectiveness-postpartum',

  // Section 4: Routine
  naturalMethod = 'natural-method',
  yourMeasuringDevice = 'your-measuring-device',
  whichWearable = 'which-wearable',
  consideringPurchase = 'considering-purchase',
  eligibleAppleWatch = 'eligible-apple-watch',
  purchaseNewWatch = 'purchase-new-watch',
  howDoYouSleep = 'how-do-you-sleep',
  sleepWearable = 'sleep-wearable',
  wearYourWatchToBed = 'wear-your-device-to-bed',

  // B1InSignupABTest start
  eligibleAppleWatchB1InSignup = 'eligible-apple-watch-b1-in-signup',
  wearYourWatchToBedB1InSignup = 'wear-your-watch-to-bed',
  whatToTrackWithDevice = 'what-to-track-with-device',
  sleepAndLifeStyleInfo = 'sleep-and-lifestyle-info',
  wakeUpTimeConsistency = 'wake-up-time-consistency',
  snooze = 'snooze',
  dailyRoutineConsistency = 'daily-routine-consistency',
  // B1InSignupABTest end

  yourDescription = 'your-description',
  fitResult = 'fit-result',
  deviceResult = 'device-result',
}
